interface FeatureButtonProps {
  classes: Record<string, string>;
  title: string;
  icon: string;
}

const NAME = 'feature-btn';

export const getFeatureButton = (root: HTMLElement, featureName: string) =>
  root.querySelector<HTMLButtonElement>(`button[title="${featureName}"]`);

export const isFeatureButton = (target: HTMLElement) =>
  (target as HTMLButtonElement).name === NAME;
export const featureButton = ({ classes, icon, title }: FeatureButtonProps) => {
  return `<button name='${NAME}' title='${title}' class='${classes.item}' type='button'>
            <span class='${classes.itemIcon}'>
              ${icon}
            </span>
            <span class='${classes.itemTitle}'>${title}</span>
        </button>`;
};
